export const iconFontAwesomeCampingMosquito = (
	<i className="fa-solid fa-mosquito"></i>
);
